export default __webpack_public_path__ + "a15cc710d5b1f2d9c64706156125e0a6.svg";